export default __webpack_public_path__ + "static/media/m_products.69f5ea69.png";